module.exports = __webpack_public_path__ + "static/media/10.ca51796e.jpg";